import React, { useState } from 'react'
import { Popconfirm, PopconfirmProps } from 'antd'
import { useMemoizedFn } from 'ahooks'

export type { PopconfirmProps }

const DEFAULT_CONFIRM_PROPS: PopconfirmProps = {
    title: '确认执行此操作吗',
    placement: 'top',
    okText: '确定',
    cancelText: '取消',
    autoAdjustOverflow: true,
    arrowPointAtCenter: true,
}
export default (props: PopconfirmProps) => {
    const { onConfirm, ...restProps } = props
    const [loading, setLoading] = useState(false)

    const onConfirmHelper: PopconfirmProps['onConfirm'] = useMemoizedFn(async e => {
        setLoading(true)
        await onConfirm?.(e)
        setLoading(false)
    })

    /**
     * 不能加useMemo，加了之后组件的children不render
     */
    const mergedConfirmProps: PopconfirmProps = {
        ...DEFAULT_CONFIRM_PROPS,
        onConfirm: onConfirmHelper,
        okButtonProps: { loading },
        ...restProps,
    }

    return <Popconfirm onConfirm={onConfirmHelper} {...mergedConfirmProps} />
}
